export const homeTypes = {
  alertCR: {
    cr: '',
    diasVencimento: '',
  },
  finance: {
    quantidadePendencias: '',
  },
}
